import { render, staticRenderFns } from "./MasterAccountFormModal.vue?vue&type=template&id=4c2485c0"
import script from "./MasterAccountFormModal.vue?vue&type=script&lang=js"
export * from "./MasterAccountFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports